import { availableAssetTypes } from '@brickwise/asset-validation/dist/utils';
import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@mui/material';
import { useAssetType } from 'src/context-providers/asset-type/AssetTypeContext';
import { AssetType } from 'src/models';
import { useUser } from 'src/hooks/useUser';

interface Props {
  disabled: boolean;
}

export const AssetTypeSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const { assetType, setAssetType } = useAssetType();

  const onAssetTypeChange = (newAssetType: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setAssetType(newAssetType.target.value as AssetType);
  };

  const userObject = useUser();

  // This box should only be rendered if the user can create more than one asset type
  if (userObject?.partner?.assetType.length && userObject?.partner?.assetType.length > 1) {
    return (
      <TextField
        margin="normal"
        label={t('general.assetType.selector')}
        variant="outlined"
        fullWidth
        disabled={disabled}
        select
        style={{ textAlign: 'left' }}
        value={assetType}
        onChange={onAssetTypeChange}
      >
        {availableAssetTypes.map((value) => {
          return (
            <MenuItem key={value} value={value}>
              {t(`general.assetType.${value}.label`)}
            </MenuItem>
          );
        })}
      </TextField>
    );
  }

  return <></>;
};
